/**
 * settingCard.tsx
 */
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/settingCardContainer';
import MosaicContext from '@shared/components/utils/context/mosaicContext';
import Setting from '@shared/classes/setting';
import Title from '@components/atoms/text/settingCardTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { memo, useContext } from 'react';

/**
 * Setting card component. Displays a settings entry as an icon with a title
 * over a solid gradient card, used exclusively by the settings mosaic.
 *
 * @param {Card} props - Component props including item, focus and onClick handler
 * @returns {JSX.Element} Setting card element
 */
function SettingCard({ focused, hide, item, onClick }: Card) {
  const { hoverAsset } = useContext(MosaicContext);
  const { Icon, title } = (item as Setting) || {};

  return (
    <Container
      id='settingCardContainer'
      focused={focused}
      hide={hide}
      onClick={onClick}
      onMouseEnter={() => hoverAsset(item)}
    >
      {Icon ? <Icon /> : null}
      <Title>{TranslationManager.get(title)}</Title>
    </Container>
  );
}

export default memo(SettingCard);
